module.exports = __webpack_public_path__ + "media/add_new_server.a6b97738.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/cloud/server/add_new_server.png
// module id = 739
// module chunks = 2